import { Box, Typography } from '@mui/material'
import React from 'react'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

export const CutCurrency = ({fontSize,iconSize,value}) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                position: "relative",
                width: "fit-content",
                "&::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: "50%",
                    height: "2px",
                    backgroundColor: "red.main",
                    transform: "translateY(-50%)"
                }
            }}
        >
            <CurrencyRupeeIcon sx={{ fontSize:iconSize|| "18px", color: "grey.400" }} />
            <Typography fontSize={fontSize} variant='body1'  color='grey.400' fontWeight={400}>
            {value}
            </Typography>
        </Box>
    )
}
